import { readOnlyFileUI } from "../commons";
import secondaryClientForm from '../secondary/NonCreditContractsDownloadPersonalClientSchema';

const form = {
    title: "Carga Contratos",
    displayName: 'NonCreditContractsDownloadPersonalClient',
    page: 'non-credit-contracts-download-personal-client',
    secondaryClientForm
};


form.schema = {
    title: "Solicitud de Vinculación Cliente Personal",
    type: "object",
    properties: {
        "enviarCorreoCliente": {
            "buttonText": "Enviar Correo a Cliente",
            subject: "Documentación completada para revisión",
            body: "Buenas tardes Sr/Sra. {nombreCliente} \n\nHemos recibido la documentación para continuar el proceso de vinculación a JMMB. Le estaremos contactando para la firma de los documentos. \n\nFavor indicarme que día y hora tienes disponible para reunirnos y proceder a la firma de la documentación.",
            type: "null",
        },
        "dct": {
            title: "Documentos Cliente Titular",
            description: "Documentos a firmar por el cliente",
            type: "object",
            properties: {
                "titlePuesto": { title: "Puesto", type: "null", const: null },
                "titleBanco": { title: "Banco", type: "null", const: null },
                "titleSafi": { title: "Safi", type: "null", const: null },
                "tarjetaDeFirmaPuesto": {
                    title: "Tarjeta de Firma",
                    type: "number",
                },
                "informeInversionistaPuesto": {
                    title: "Informe Perfil de Inversionista",
                    type: "number",
                },
                "contratoMarcoPuesto": {
                    title: "Contrato Marco",
                    type: "number",
                },
                "contratoCuentaPuesto": {
                    title: "Contrato Apertura Cuenta",
                    type: "number",
                },
                "cartaAutorizacionCuentaPuesto": {
                    title: "Carta Autorización Apertura Cuenta",
                    type: "number",
                },
                "formularioClientePuesto": {
                    title: "Formulario Conozca su Cliente",
                    type: "number",
                },
                "formularioW8BenPuesto": {
                    title: "Formulario W8-BEN",
                    type: "number",
                },
                "formularioW9Puesto": {
                    title: "Formulario W9",
                    type: "number",
                },
                "formularioMoneylinePuesto": {
                    title: "Formulario Solicitud Moneyline",
                    type: "number",
                },
                "tarjetaFirmaSafi": {
                    title: "Tarjeta de Firma",
                    type: "number",
                },
                "informeInversionistaSafi": {
                    title: "Informe Perfil de Inversionista",
                    type: "number",
                },
                "contratoMarcoSafi": {
                    title: "Contrato Marco",
                    type: "number",
                },
                "formularioClienteSafi": {
                    title: "Formulario Conozca su Cliente",
                    type: "number",
                },
                "formularioW8BenSafi": {
                    title: "Formulario W8-BEN",
                    type: "number",
                },
                "formularioW9Safi": {
                    title: "Formulario W9",
                    type: "number",
                },
                "formularioMoneylineSafi": {
                    title: "Formulario Solicitud Moneyline",
                    type: "number",
                },
                "tarjetaFirmaBanco": {
                    title: "Tarjeta de Firma",
                    type: "number",
                },
                "formularioClienteBanco": {
                    title: "Formulario Conozca su Cliente",
                    type: "number",
                },
                "contratoMarcoBanco": {
                    title: "Contrato Marco",
                    type: "number",
                },
                "contratoCuentaBanco": {
                    title: "Contrato Apertura Cuenta",
                    type: "number",
                },
                "formularioW8BenBanco": {
                    title: "Formulario W8-BEN",
                    type: "number",
                },
                "formularioW9Banco": {
                    title: "Formulario W9",
                    type: "number",
                },
                "formularioMoneylineBanco": {
                    title: "Formulario Solicitud Moneyline",
                    type: "number",
                },
                "formularioSujetoObligado": {
                    title: "Formulario Sujeto Obligado No Financiero Persona Física",
                    type: "number",
                },
                "solicitudPrestamoDL": {
                    title: "Solicitud de Préstamo",
                    type: "number"
                },
                "designacionCuentaBancariaSAFI": {
                    title: "Formulario de cuenta autorizada por el cliente para pago de rescates (Designación de cuenta bancaria SAFI)",
                    type: "number",
                },
                "formularioAperturaCertificado": {
                    title: "Formulario Apertura de Certificado",
                    type: "number",
                },
            }
        },
    },
    required: [],
};



form.uiSchema = {
    "enviarCorreoCliente": { "ui:field": "SendEmail" },
    "dct": {
        "classNames": "personalNonCCD-dct",
        "ui:field": "HideObjectField",
        "titlePuesto": { classNames: "title                   puesto" },
        "titleBanco": { classNames: "title                   banco" },
        "titleSafi": { classNames: "title                   safi" },
        "tarjetaDeFirmaPuesto": { ...readOnlyFileUI, classNames: "tarjetaDeFirma          puesto" },
        "informeInversionistaPuesto": { ...readOnlyFileUI, classNames: "informeInversionista    puesto" },
        "contratoMarcoPuesto": { ...readOnlyFileUI, classNames: "contratoMarco           puesto" },
        "contratoCuentaPuesto": { ...readOnlyFileUI, classNames: "contratoCuenta          puesto" },
        "cartaAutorizacionCuentaPuesto": { ...readOnlyFileUI, classNames: "cartaAutorizacionCuenta puesto" },
        "formularioClientePuesto": { ...readOnlyFileUI, classNames: "formularioCliente       puesto" },
        "formularioW8BenPuesto": { ...readOnlyFileUI, classNames: "formularioW8Ben         puesto" },
        "formularioW9Puesto": { ...readOnlyFileUI, classNames: "formularioW9            puesto" },
        "formularioMoneylinePuesto": { ...readOnlyFileUI, classNames: "formularioMoneyline     puesto" },
        "tarjetaFirmaSafi": { ...readOnlyFileUI, classNames: "tarjetaFirma            safi" },
        "informeInversionistaSafi": { ...readOnlyFileUI, classNames: "informeInversionista    safi" },
        "contratoMarcoSafi": { ...readOnlyFileUI, classNames: "contratoMarco           safi" },
        "formularioClienteSafi": { ...readOnlyFileUI, classNames: "formularioCliente       safi" },
        "formularioW8BenSafi": { ...readOnlyFileUI, classNames: "formularioW8Ben         safi" },
        "formularioW9Safi": { ...readOnlyFileUI, classNames: "formularioW9            safi" },
        "formularioMoneylineSafi": { ...readOnlyFileUI, classNames: "formularioMoneyline     safi" },
        "tarjetaFirmaBanco": { ...readOnlyFileUI, classNames: "tarjetaFirma            banco" },
        "formularioClienteBanco": { ...readOnlyFileUI, classNames: "formularioCliente       banco" },
        "contratoMarcoBanco": { ...readOnlyFileUI, classNames: "contratoMarco           banco" },
        "contratoCuentaBanco": { ...readOnlyFileUI, classNames: "contratoCuenta          banco" },
        "formularioW8BenBanco": { ...readOnlyFileUI, classNames: "formularioW8Ben         banco" },
        "formularioW9Banco": { ...readOnlyFileUI, classNames: "formularioW9            banco" },
        "formularioMoneylineBanco": { ...readOnlyFileUI, classNames: "formularioMoneyline     banco" },
        "formularioSujetoObligado": { ...readOnlyFileUI, classNames: "formularioSujetoObligado puesto" },
        "solicitudPrestamoDL": { ...readOnlyFileUI, classNames: "solicitudPrestamoDL" },
        "designacionCuentaBancariaSAFI": { ...readOnlyFileUI, classNames: "designacionCuentaBancariaSAFI        safi" },
        "formularioAperturaCertificado": { ...readOnlyFileUI, classNames: "formularioAperturaCertificado        banco" },
    },
};

form.objectMap = {
    // Puesto
    "generatedFiles.fullkyc_0_TarjetaDeFirmaPuesto": "dct.tarjetaDeFirmaPuesto",
    "generatedFiles.fullkyc_0_InformePerfilDeInversionistaPuesto": "dct.informeInversionistaPuesto",
    "generatedFiles.fullkyc_0_ContratoMarcoPuesto": "dct.contratoMarcoPuesto",
    "generatedFiles.fullkyc_0_ContratoAperturaCuentaPuesto": "dct.contratoCuentaPuesto",
    "generatedFiles.fullkyc_0_CartaAutorizaciónAperturaCuentaPuesto": "dct.cartaAutorizacionCuentaPuesto",
    "generatedFiles.fullkyc_0_FormularioConozcaSuClientePuesto": "dct.formularioClientePuesto",
    "generatedFiles.fullkyc_0_FormularioSolicitudMoneylinePuesto": "dct.formularioMoneylinePuesto",
    "generatedFiles.fullkyc_0_IrsW8benPuesto": "dct.formularioW8BenPuesto",
    "generatedFiles.fullkyc_0_IrsW9SpPuesto": "dct.formularioW9Puesto",
    // SAFI
    "generatedFiles.fullkyc_0_TarjetaDeFirmaSafi": "dct.tarjetaFirmaSafi",
    "generatedFiles.fullkyc_0_InformePerfilDeInversionistaSafi": "dct.informeInversionistaSafi",
    "generatedFiles.fullkyc_0_ContratoMarcoSafi": "dct.contratoMarcoSafi",
    "generatedFiles.fullkyc_0_FormularioConozcaSuClienteSafi": "dct.formularioClienteSafi",
    "generatedFiles.fullkyc_0_FormularioSolicitudMoneylineSafi": "dct.formularioMoneylineSafi",
    "generatedFiles.fullkyc_0_IrsW8benSafi": "dct.formularioW8BenSafi",
    "generatedFiles.fullkyc_0_IrsW9SpSafi": "dct.formularioW9Safi",
    "generatedFiles.fullkyc_0_FormularioDeCuentaAutorizadaPorElClienteParaPagoDeRescatesDesignaciónDeCuentaBancariaSafiFísica": "dct.designacionCuentaBancariaSAFI",

    // Banco
    "generatedFiles.fullkyc_0_TarjetaDeFirmaBanco": "dct.tarjetaFirmaBanco",
    "generatedFiles.fullkyc_0_ContratoMarcoBanco": "dct.contratoMarcoBanco",
    "generatedFiles.fullkyc_0_ContratoAperturaCuentaBanco": "dct.contratoCuentaBanco",
    "generatedFiles.fullkyc_0_FormularioConozcaSuClienteBanco": "dct.formularioClienteBanco",
    "generatedFiles.fullkyc_0_FormularioSolicitudMoneylineBanco": "dct.formularioMoneylineBanco",
    "generatedFiles.fullkyc_0_IrsW8benBanco": "dct.formularioW8BenBanco",
    "generatedFiles.fullkyc_0_IrsW9SpBanco": "dct.formularioW9Banco",

    "generatedFiles.fullkyc_0_SujetoObligadoPersonal": "dct.formularioSujetoObligado",
    "generatedFiles.fullkyc_0_FormularioAperturaDeCertificadoFísica": "dct.formularioAperturaCertificado",

    // Loan
    "generatedFiles.fullkyc_0_SolicitudDePrestamoPersonal": "dct.solicitudPrestamoDL",
}


export default form;